import { IsNotEmpty, IsOptional, IsString } from 'class-validator';
import { OptionalStringTransform } from '../../validation/optional-string.transformer';

/**
 * `expectedPayloadHash` follows the same attestation pattern used by the lot
 * allergen-discrepancy gate (`allergenDiscrepancyAck`): the client sends a
 * token for the payload it displayed, the server recomputes and compares,
 * and a mismatch is a 409 with the fresh payload in the body — never a
 * silent overwrite of data the user never actually read.
 * `signatureStorageKey` references the user's already-saved signature
 * (never fabricated); `correctionReason` is required by the service layer
 * only when this confirmation supersedes a prior one.
 */
export class ConfirmCounterLabelDto {
  @IsString()
  @IsNotEmpty()
  expectedPayloadHash!: string;

  @IsOptional()
  @IsString()
  @OptionalStringTransform()
  signatureStorageKey?: string;

  @IsOptional()
  @IsString()
  @OptionalStringTransform()
  correctionReason?: string;
}
